// extracted by mini-css-extract-plugin
module.exports = {"trait":"CharactersSpeciesDetailHalfHuman_trait_1WJsE"};